import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../app/Component/home/home.component';
import { AboutUsComponent } from '../app/Component/about-us/about-us.component';
import { ToursComponent } from '../app/Component/tours/tours.component';
import { JoinOurTeamComponent } from '../app/Component/join-our-team/join-our-team.component'
import { FacultyComponent } from '../app/Component/faculty/faculty.component';
import { FacultyDetailsComponent } from '../app/Component/faculty-details/faculty-details.component';
import { ContactUsComponent } from '../app/Component/contact-us/contact-us.component';
import { EventDetailsComponent } from './Component/event-details/event-details.component';
import { LivestreamComponent } from '../app/Component/livestream/livestream.component';
import { OurRulesComponent } from './Component/our-rules/our-rules.component';
import { NewsComponent } from './Component/news/news.component';
import { NewsDetailsComponent } from './Component/news-details/news-details.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'tours', component: ToursComponent },
  { path: 'join-our-team', component: JoinOurTeamComponent },
  { path: 'faculty', component: FacultyComponent },
  { path: 'faculty-detail/:seoname', component: FacultyDetailsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'event-details/:eventseoname', component: EventDetailsComponent },
  { path: 'livestream', component: LivestreamComponent },
  { path: 'our-rules', component: OurRulesComponent },
  /*{ path: 'news', component: NewsComponent },*/
  { path: 'news-details/:seoname', component: NewsDetailsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
